import React from "react";
import { Quote, Star, Sparkles } from "lucide-react";
import { siteData } from "../mock";

const Testimonials = () => {
  return (
    <section className="relative py-28 bg-[#080b14] overflow-hidden">
      <div className="aurora float-slow" style={{ width: 420, height: 420, background: "#3b82f6", bottom: "-20%", right: "10%", opacity: 0.25 }} />
      <div className="relative max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/[0.05] border border-white/15 text-[11px] tracking-[0.2em] font-semibold text-blue-300">
            <Sparkles className="w-3 h-3" /> LOVED BY TEAMS
          </span>
          <h2 className="mt-4 text-3xl md:text-5xl font-bold tracking-tight text-white">
            Trusted by teams <span className="gradient-text">across the UK.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {siteData.testimonials.items.map((t, i) => (
            <div
              key={i}
              className="group relative p-7 rounded-2xl grad-border hover:-translate-y-1 hover:shadow-[0_20px_50px_-20px_rgba(99,102,241,0.6)] transition-all"
            >
              <Quote className="w-8 h-8 text-blue-400/50 mb-4" />
              <p className="text-white/85 leading-relaxed">{t.quote}</p>
              <div className="mt-6 flex items-center gap-1 text-blue-400">
                {[...Array(5)].map((_, k) => (
                  <Star key={k} className="w-4 h-4 fill-current" />
                ))}
              </div>
              <div className="mt-4 pt-4 border-t border-white/10 flex items-center gap-3">
                <span className="w-9 h-9 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white font-bold text-sm">
                  {t.author.split(" ").map((n) => n[0]).join("")}
                </span>
                <div>
                  <p className="font-semibold text-white text-sm">{t.author}</p>
                  <p className="text-xs text-white/55">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
